import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { extendTheme, ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { StepsStyleConfig as Steps } from "chakra-ui-steps";
import { ConfigProvider } from 'antd';
// Extend the theme to include custom colors, fonts, etc
const colors = {
  blue: {
    50: "#E5F5FF",
    100: "#B8E3FF",
    200: "#8AD2FF",
    300: "#5CC0FF",
    400: "#2EAEFF",
    500: "#079FFF",
    600: "#007DCC",
    700: "#005E99",
    800: "#003F66",
    900: "#001F33",
  },
  red: {
    50: "#FFE6E7",
    100: "#FFB8BC",
    200: "#FE8A92",
    300: "#FE5D67",
    400: "#FE2F3C",
    500: "#FE414D",
    600: "#CB010E",
    700: "#98010A",
    800: "#650107",
    900: "#330003",
  },
  gray: {
    50: "#F2F2F2",
    100: "#DBDBDB",
    200: "#C4C4C4",
    300: "#ADADAD",
    400: "#969696",
    500: "#808080",
    600: "#666666",
    700: "#4D4D4D",
    800: "#333333",
    900: "#1A1A1A",
  },
  green: {
    50: "#E5FFFB",
    100: "#B8FFF4",
    200: "#8AFFED",
    300: "#5CFFE6",
    400: "#2EFFDF",
    500: "#00E6C3",
    600: "#00CCAD",
    700: "#009982",
    800: "#006656",
    900: "#00332B",
  },
  yellow: {
    50: "#FFFCE5",
    100: "#FFF6B8",
    200: "#FFF08A",
    300: "#FFEA5C",
    400: "#FFE63B",
    500: "#FFDE00",
    600: "#CCB200",
    700: "#998500",
    800: "#665900",
    900: "#332C00",
  },
};

const fonts = {
  body: "FuturaNext_Book",
  heading: "FuturaNext_Book",
};

const theme = extendTheme({
  colors,
  fonts,
  components: {
    Steps,
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "FuturaNext_Book"
            },
          }}
        >
          <App />
        </ConfigProvider>
      </ChakraProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
